import { useQuery } from '@tanstack/react-query';
import axios from './api';
import { getComboCache, setComboCache, buildComboCacheKey } from './utils/indexedDBPersister';

export const useLookup = ({
  // Tablo sorgusu için
  tableName,
  idField,
  textField,
  filter,
  // Function sorgusu için
  functionName,
  functionParameters,
  // Ortak parametreler
  connectionName = 'SarisDb',
  staleTime = 500 * 60 * 1000,   // Varsayılan: 5 dakika
  cacheTime = 700 * 60 * 1000,   // Varsayılan: 10 dakika
}) => {
  // Function mu yoksa Table sorgusu mu?
  const isFunction = !!functionName;

  // functionParameters'daki değerlerin dolu olup olmadığını kontrol et
  const hasValidFunctionParams = functionParameters
    ? Object.values(functionParameters).every(val => val !== undefined && val !== null && val !== '')
    : false;

  // Query key - function veya table'a göre farklı
  const queryKey = isFunction
    ? ['lookup', 'function', functionName, idField, textField, JSON.stringify(functionParameters), connectionName]
    : ['lookup', 'table', tableName, idField, textField, filter, connectionName];

  return useQuery({
    queryKey,
    queryFn: async () => {
      // ---------- IndexedDB combo cache kontrolü (sadece tablo sorguları için) ----------
      if (!isFunction && tableName) {
        const cacheKey = buildComboCacheKey(tableName, filter, idField, textField);
        try {
          const cached = await getComboCache(cacheKey);
          if (cached !== null) {
            return cached;
          }
        } catch {
          // IndexedDB okuma hatası — normal API akışına devam et
        }
      }

      // Request body oluştur
      const requestBody = isFunction
        ? {
          functionName,
          idField,
          textField,
          functionParameters,
          connectionName
        }
        : {
          tableName,
          idField,
          textField,
          filter,
          connectionName
        };

      const { data } = await axios.post(`/GetCombo`, requestBody);

      // ---------- Başarılı API yanıtını IndexedDB'ye kaydet (tablo sorguları için) ----------
      if (!isFunction && tableName && data) {
        const cacheKey = buildComboCacheKey(tableName, filter, idField, textField);
        // Fire-and-forget: arka planda kaydet, hata olursa sessizce geç
        setComboCache(cacheKey, data).catch(() => {});
      }

      return data;
    },
    enabled: isFunction ? (!!functionName && hasValidFunctionParams) : !!tableName,
    staleTime,      // Verinin "bayat" sayılacağı süre
    gcTime: cacheTime // Kullanılmayan verinin cache'de kalacağı süre (v5'te cacheTime -> gcTime)
  });
};
